import React, { useState } from 'react';
import Screening from './index';
import Button from '@hubins/components/Button';
import Modal from '@hubins/components/Modal';

const ApprovalModal = ({client}) => {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setIsOpen(true)} icon="add" className="s-top-l">
        Screening
      </Button>
      <Modal open={isOpen} callback={setIsOpen} closeButton shouldCloseOnOverlayClick>
        <Screening client={client} />
      </Modal>
    </>
  )
};

export default ApprovalModal;